export const clients = {
	place: "Local",
	titleWithPlace: "Lista de clientes",
	searchTitle: "Tipo de documento",
	searchPlaceholder: "Digite o documento",
	searchClientByName: "Digite o nome",
	documentTypePlaceHolder: "Selecione o tipo de documento",
	filterTitle: "Filtros avançados",
	filterByProductTitle: "Filtrar por produto",
	clearFilter: "Limpar todos os campos",
	applyFilter: "Aplicar filtros",
	productError: "A quantidade de {{product}} deve ser maior que zero",
	filter: {
		period: "Período",
		gender: "Gênero",
		genderPlaceholder: "Selecione o(s) gênero(s)",
		periodFrequency: "Frequência",
		firstTime: "1ª vez",
		frequencyPlaceholder: "Escolha a frequência do cliente",
		daysOfTheWeek: "Dias da semana",
		daysOfTheWeekPlaceholder: "Selecione os dias da semana",
		productsConsumed: "Produtos consumidos",
		product: "Produto",
		selectProduct: "Selecione um produto",
		noProducts: "Nenhum produto encontrado",
		quantity: "Quantidade",
		removeProduct: "Remover produto",
		addProduct: "Adicionar outro produto",
		consumptionVolume: "Consumação mínima",
		notUsedRecharges: "Resíduo de recarga mínima",
		birthdateRange: "Período de Aniversário",
		birthdateYear: "Ano de Aniversário",
		yearPlaceholder: "aaaa",
		products: "Produto(s)",
		productsPlaceholder: "Selecione o(s) produto(s)",
		errors: {
			type: "Dados inválidos",
			birthdate: {
				day: "Dados inválidos",
				month: "Dados inválidos",
				year: "Insira um ano entre 1900 e o ano atual",
			},
		},
	},
	table: {
		name: "Cliente",
		cpf: "CPF",
		phone: "Telefone",
		birthDate: "Data de aniversário",
		uninformed: "Não informado",
		email: "E-mail",
		presences: "Presença",
		consumption: "Consumiu",
		remaningValueOnPlace: "Saldo disponível",
		hasApp: "Aplicativo ativo",
		moreThan: "mais de ",
		countClients_one: "cliente encontrado",
		countClients_other: "clientes encontrados",
		countTicketClients: "ticket médio por cliente",
		infoLabel: "Selecione um cliente para ver detalhes.",
		infoLabelTable: "Selecione uma Mesa para ver detalhes.",
		emptyText: "Sem dados a serem exibidos",
		moreResults: "Carregar mais resultados",
		firstTimeAtPlace: "1ª vez",
		lastTimeAtPlace: "Última visita",
	},
	cancel: "Cancelar",
	search: "Buscar",
	gender: {
		male: "Homem",
		female: "Mulher",
		others: "Outros",
	},
	daysOfTheWeek: {
		monday: "Segunda",
		tuesday: "Terça",
		wednesday: "Quarta",
		thursday: "Quinta",
		friday: "Sexta",
		saturday: "Sábado",
		sunday: "Domingo",
	},
};
